import type { FeatureCollection, Point } from 'geojson';

import { ServiceStatus } from '../constants';
import { MapMarker } from '../types';

export interface MarkerFeatureProperties {
  status: string;
  markerIndex: number;
}

export type MarkerFeatureCollection = FeatureCollection<
  Point,
  MarkerFeatureProperties
>;

/**
 * `markerIndex` (rather than the `MapMarker` itself) is stored in each
 * feature's properties because `MapMarker.getStatus` is a function and
 * GeoJSON properties must round-trip through MapLibre's tile cache as
 * plain JSON. Callers index back into their own `markers` array to
 * resolve the full `MapMarker` on click.
 */
export function buildMarkerFeatureCollection(
  markers: MapMarker[],
): MarkerFeatureCollection {
  return {
    type: 'FeatureCollection',
    features: markers.map((marker, markerIndex) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [+marker.longitude, +marker.latitude],
      },
      properties: {
        status: marker.getStatus() ?? ServiceStatus.UP,
        markerIndex,
      },
    })),
  };
}
